import { Connector }        from '@mathquis/modelx';
import { ConnectorResult }  from '@mathquis/modelx';
import { ConnectorResults } from '@mathquis/modelx';
import { Model }            from '@mathquis/modelx';
import axios                from 'axios';
import qs                   from 'qs';

export class PublicApiConnector extends Connector {
  public client: any;

  public destroy(model: Model, options = {}) {
    return this
      .request(model.path, {
        method: 'delete',
        ...options,
      })
      .then((response: any) => new ConnectorResult(model.attributes, response));
  }

  public fetch(model: Model, options = {}) {
    return this
      .request(model.path, {
        method: 'get',
        ...options,
      })
      .then((response: any) => new ConnectorResult(response.data, response));
  }

  public initialize() {
    this.client = axios.create({
      ...this.options,
      headers: {
        ...this.options.headers,
        Accept: 'application/ld+json',
      },
      responseType: 'json',
    });
  }

  public list(collection: any, options: any = {}) {
    const params = { ...options.filters };

    params.pagination = !!(options.limit || options.offset);
    if (params.pagination) {
      if (options.limit) {
        params.itemsPerPage = Math.max(1, options.limit);
      }
      if (options.offset) {
        params.page = Math.floor(options.offset / Math.max(1, params.itemsPerPage)) + 1;
      }
    }

    if (options.sorts) {
      Object.keys(options.sorts).forEach(key => {
        params[`order[${key}]`] = options.sorts[key] ? 'ASC' : 'DESC';
      });
    }

    return this
      .request(collection.path, {
        ...options,
        method: 'get',
        params,
      })
      .then((response: any) => new ConnectorResults(response.data.data, response));
  }

  public onRequestError(err: any) {
    throw err;
  }

  public request(path: string, options = {}) {
    if (!this.client) {
      this.initialize();
    }

    return this.client
      .request({
        url: path.replace(/\/$/, ''),
        ...options,
      })
      .catch((err: any) => {
        return this.onRequestError(err);
      });
  }

  public save(model: Model, options: any = {}) {
    const data = qs.stringify(options.patchAttributes || model.untransformedAttributes);

    return this
      .request(model.path, {
        data,
        method: model.id ? 'put' : 'post',
        ...options,
      })
      .then((response: any) => new ConnectorResult(response.data, response));
  }
}
